import Vue from 'vue';
import orderState from '@/utils/orderState';

export default (order) => {
  order.orderState = orderState.get('unpaid').value;
  return Vue.$http.post('Orders', order);
};



// WEBPACK FOOTER //
// ./src/services/order/create.js